function announceAction(button, label) {
    button.dataset.originalLabel = button.dataset.originalLabel || button.textContent.trim();
    button.textContent = label;

    window.clearTimeout(button._announceTimeout);
    button._announceTimeout = window.setTimeout(function () {
        button.textContent = button.dataset.originalLabel;
    }, 2000);
}

async function shareProject(button) {
    var url = window.location.href;
    var shareData = {
        title: document.title,
        url: url
    };

    if (navigator.share) {
        try {
            await navigator.share(shareData);
            return;
        } catch (error) {
            if (error && error.name === 'AbortError') {
                return;
            }
        }
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        try {
            await navigator.clipboard.writeText(url);
            announceAction(button, 'Link copied');
            return;
        } catch (error) {
            console.warn('project-plan-hero clipboard write failed', error);
        }
    }

    window.prompt('Copy this project URL:', url);
}

export function initProjectPlanHero(root = document) {
    root.querySelectorAll('.pplan-hero [data-share]:not([data-share-bound])').forEach(function (button) {
        button.dataset.shareBound = 'true';

        button.addEventListener('click', function () {
            shareProject(button);
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initProjectPlanHero();
    });
} else {
    initProjectPlanHero();
}
